import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2bcee3b6"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bcee3b6')) {
      api.createRecord('2bcee3b6', component.options)
    } else {
      api.reload('2bcee3b6', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=2bcee3b6", function () {
      api.rerender('2bcee3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/helpdesk/Search/Main.vue"
export default component.exports